import script from "./activity.vue?vue&type=script&setup=true&lang=js"
export * from "./activity.vue?vue&type=script&setup=true&lang=js"

import "./activity.vue?vue&type=style&index=0&id=57f5d44b&lang=scss"

const __exports__ = script;

export default __exports__